import { ProjectData } from '@belimo-retrofit-portal/logic';
import { PROJECT_VERSION } from 'src/modules/project-new/constants/projectData';

export function cleanImportData(
  importData: ProjectData,
): ProjectData {
  return {
    version: PROJECT_VERSION,

    title: importData.title,
    goals: importData.goals,
    status: importData.status,
    statusComment: importData.statusComment,
    building: importData.building,
    currency: importData.currency,
    participants: importData.participants,
    hvac: importData.hvac,
    evaluation: importData.evaluation,

    cover: null,
    report: {
      ...importData.report,
      appendix: {
        ...importData.report.appendix,
        files: [],
      },
    },
  };
}
